import { useState, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import TwoButtonsModal from '../modals/TwoButtonsModal'
import * as Constants from '../../utils/constants'
import alagemIcon from '../../assets/alagem-icon.png'
import strings from '../../res/strings'
import { UserContext } from '../../App'

const TopNavBar = () => {
    const [showLogoutModal, setShowLogoutModal] = useState(false)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    // Handle the logout
    const logout = () => {
        localStorage.removeItem('rememberUser')
        localStorage.removeItem('authToken')
        
        setLoggedUser(null)
        navigate('/')
    }

    return (
        <>
            <nav className='h-14 bg-navy px-[12.5rem] flex items-center justify-between'>
                <div className='flex flex-row items-center space-x-4'>
                    <img className='h-[1.875rem] w-[1.875rem]' src={alagemIcon} alt='Alagem Logo'/>
                    <p className='font-montserrat text-white'>{strings.title}</p>
                </div>
                
                <div className='flex flex-row items-center space-x-8'>
                    { loggedUser ?
                        loggedUser.role !== Constants.Roles.CLIENT ?
                            <>
                                <p className='font-montserrat text-white font-semibold'>{loggedUser.name} { Constants.getRoleNameById(loggedUser.role) }</p> 
                                <p onClick={() => setShowLogoutModal(true)} className='font-montserrat text-white font-semibold underline cursor-pointer'>{strings.exit}</p>
                            </>
                        :   <>
                                <Link to='/profile' className='font-montserrat text-white font-semibold cursor-pointer'>{loggedUser.name}</Link> 
                                <p onClick={() => setShowLogoutModal(true)} className='font-montserrat text-white font-semibold underline cursor-pointer'>{strings.exit}</p>
                            </>
                    : null }
                </div>
            </nav>
            
            <TwoButtonsModal
                open={showLogoutModal}
                onClose={() => setShowLogoutModal(false)}
                title={strings.signOut}
                message={strings.signOutMessage}
                buttonText1={strings.back}
                buttonText2={strings.signOutTitle}
                onClick={logout}
            />
    
        </>
    )
}

export default TopNavBar